import Post from "../components/Post";
import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Loader } from "lucide-react";
import "./loader.css";

export default function CategoryPosts() {
  const [posts, setPosts] = useState([]);
  const [category, setCategory] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();

  const fetchPosts = async () => {
    try {
      const response = await axios.get(
        `https://skblogs-backend.netlify.app/api/posts/category/${id}`
      );
      setPosts(response.data);
      setIsLoading(false);
    } catch (e) {
      console.log("Response Failed", e);
    }
  };

  const fetchCategory = async () => {
    try {
      const response = await axios.get(
        `https://skblogs-backend.netlify.app/api/categories/${id}`
      );
      setCategory(response.data);
    } catch (e) {
      console.log("Response Failed", e);
    }
  };

  let centerLoading =
    posts.length > 0
      ? ""
      : "d-flex flex-cloumn align-items-center justify-content-center";

  useEffect(() => {
    fetchPosts();
    fetchCategory();
  }, []);

  return (
    <>
      <main style={{ minHeight: "81.7vh"}} className={centerLoading}>
        {isLoading ? (
          <div className="col-12 w-100 d-flex flex-cloumn align-items-center justify-content-center">
            <Loader className="loader" />
          </div>
        ) : (
          <div className="container mt-4">
            <div className="row">
              <div className="col-lg-8">
                <h1 className="mb-4">{category?.name}</h1>

                {posts.length > 0 ? (
                  posts.map((post, i) => <Post key={i} post={post} />)
                ) : (
                  <h3 className="mb-3">No Posts Available</h3>
                )}
              </div>
            </div>
          </div>
        )}
      </main>
    </>
  );
}
